export const defaultStyle = {
    mainContent: "max-w-xl mx-auto px-[15px]",
    LinkContent: "relative w-100% px-[15px] box-border",
    LinkContentTwo: "relative w-100% px-[15px] box-border mt-0",
    Home: "font-Regular text-[14px] md:text-[21px] px-[15px] font-bold  tracking-[2.2px]  text-purple box-border cursor-pointer hover:underline  w-100%",
    LinkTwo: "font-Regular text-[14px] md:text-[21px] px-[15px] font-bold tracking-[2.2px]  text-purple box-border cursor-pointer hover:underline  w-100%",
    LinkThree: "font-Regular text-[14px] md:text-[21px] px-[15px] font-bold tracking-[2.2px]  text-purple box-border cursor-pointer hover:underline  w-100%",
}

export const SITEMAP_LAST_SECTION = {
    ...defaultStyle,
    mainContent: "max-w-xl mx-auto px-[15px] mb-[40px]",
}